import React, { useState } from 'react';
import { Box, Pagination } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** Bound mounted rows, including nested document and field collections. */
export default function PagedItems<T>({ items, children, pageSize = 25 }: {
  items: T[];
  children: (page: T[]) => React.ReactNode;
  pageSize?: number;
}) {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const count = Math.max(1, Math.ceil(items.length / pageSize));
  const current = Math.min(page, count);
  return <>
    {children(items.slice((current - 1) * pageSize, current * pageSize))}
    {count > 1 && <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <Pagination aria-label={t('common.pagination')} count={count} page={current} onChange={(_, value) => setPage(value)} />
    </Box>}
  </>;
}
